module.exports = __webpack_public_path__ + "static/media/drontenaar.43b2ba37.png";